import PropTypes from 'prop-types';
import React from 'react';
import LanguageBlock from '../../SharedComponents/LanguageBlock';
import FormWrapper from '../../SharedComponents/FormWrapper.jsx';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import TranslationProviderBlock from '../../../../common/TranslationProviderBlock/TranslationProviderBlock.jsx';
import { CollapseBlock } from '../../../../common/index.jsx';
import WritersPicker from '../../News/NewsEdit/WritersPicker/WritersPicker.jsx';
import useIsUserAdmin from '../../../../../hooks/useIsUserAdmin.jsx';

const ArticleForm = ({
  initials,
  creator,
  isEdit,
  onSubmit,
  visibleElement,
  setVisibleElement,
  setFormDisabledStates,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const isAdmin = useIsUserAdmin();

  return (
    <FormWrapper
      initials={initials}
      creator={creator}
      onSubmit={onSubmit}
      directory={'articles'}
      visibleElement={visibleElement}
      setVisibleElement={setVisibleElement}
      setFormDisabledStates={setFormDisabledStates}
      form={form}
    >
      <LanguageBlock language="sk" title={t('Slovenská verzia')} />
      <TranslationProviderBlock
        form={form}
        srcLang="sk"
        targetLang="en"
        fields={['title','content']}
      />
      <LanguageBlock language="en" title={t('Anglická verzia')} />
      {isEdit && isAdmin && (
        <CollapseBlock collapsible title={t('Nastavenia')}>
          <WritersPicker
            writerParams={'articles'}
            currentWriterName={creator}
            formInstance={form}
            extra={t('Toto pole je dostupné len pre administrátora.')}
          />
        </CollapseBlock>
      )}
    </FormWrapper>
  );
};

ArticleForm.propTypes = {
  initials: PropTypes.object,
  creator: PropTypes.string,
  isEdit: PropTypes.bool,
  onSubmit: PropTypes.func,
  visibleElement: PropTypes.any,
  setVisibleElement: PropTypes.func,
  setFormDisabledStates: PropTypes.func,
};

export default ArticleForm;
